import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const LogoutIcon = observer(
    'LogoutIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M10.5 24.5H5.833A2.333 2.333 0 0 1 3.5 22.167V5.833A2.333 2.333 0 0 1 5.833 3.5H10.5m8.167 16.333L24.5 14m0 0-5.833-5.833M24.5 14h-14'
            />
        </SvgElement>
    )
);
